module.exports = __webpack_public_path__ + "static/img/davis_pictgrid26_960x852.5a3dd78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/davis_pictgrid26_960x852.jpg
// module id = M0Be
// module chunks = 0